export type EmailOrPhoneId = 'email' | 'phone' | 'unknown';

export function detectEmailOrPhoneId(input: string): EmailOrPhoneId {
  const trimmed = input.trim();
  if (!trimmed) return 'unknown';
  if (trimmed.includes('@')) return 'email';
  if (/^\+/.test(trimmed) || /^[\d()\s-]{7,}$/.test(trimmed)) return 'phone';
  return 'unknown';
}
